module.exports = __webpack_public_path__ + "img/pe03.8ff1bef5.jpg";